/* esm.sh - unist-util-find-after@5.0.0 */
export * from "/*unist-util-find-after@5.0.0/esnext/unist-util-find-after.mjs";
